import { useEffect, useState } from 'react'
import InputDefault from '../../Components/UI/InputDefault'
import { useAuth } from '../../Providers/AuthProvider'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import RegistrationItemList from '../../Components/RegistrationItemList'
import { useTranslation } from 'react-i18next'
import { Button } from 'react-bootstrap'
import ErrorBoundary from '../../Components/ErrorBoundary/ErrorBoundary'
import LogInSelectCompanyModal from '../../Components/Components/Modals/LogInSelectCompanyModal';
import { toast } from 'react-toastify';
import { useParams } from '../../Providers/ParamsProvider';

import './LoginPageIndex.css'

const LoginPageIndex = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const { redirectParams } = location.state || {}
    const { login, loginError, setLoginError } = useAuth()
    const [email, setEmail] = useState(null)
    const [password, setPassword] = useState(null)
    const { t } = useTranslation()
    const [companiesToSelect, setCompaniesToSelect] = useState([])
    const { logOutClearDataFuncBody } = useAuth()
    const { isMobile } = useParams()

    useEffect(() => {
        logOutClearDataFuncBody()
    }, [])

    const loginSubmit = async (e, custId) => {
        var data = {
            login: email,
            password: password,
            custId: custId ? custId : ''
        }
        if (email && password) {
            let redirectToHomePage = redirectParams ? false : true
            const loginResponse = await login(data, redirectToHomePage)
            if (loginResponse.errorMessage && loginResponse.errorMessage.trim() != '') {
                setLoginError(loginResponse.errorMessage)
                return
            }
            if (loginResponse.manyCompanies) {
                setCompaniesToSelect(loginResponse.companies)
                return
            }
            if (redirectParams) {
                window.location.href = `/Cart?custId=${redirectParams.custId}&offerNo=${redirectParams.offerNo}&offerSiteId=${redirectParams.offerSiteId}`
            }
        } else {
            setLoginError("Należy podać login i hasło!")
        }
    }
    const handleKeyPress = (event) => {
        if (event && event.key === "Enter") {
            loginSubmit()
        }
    }
    const handleSelectCompany = (result) => {
        setCompaniesToSelect([])
        if (result) {
            loginSubmit(null, result)
        }
    }
    const handleResetPassword = () => {
        if (!email || email.trim() === '') {
            toast.warning('Proszę uzupełnić pole e-mail')
            return
        }
        navigate('/ResetPassword', { state: { email: email } })
    }

    return (<>
        <ErrorBoundary>
            <LogInSelectCompanyModal
                show={companiesToSelect.length > 0 ? true : false}
                onHide={handleSelectCompany}
                companies={companiesToSelect}
            />
            <div className='container'>
                <div className='row justify-content-center dashboard-container' style={{ marginBottom: isMobile ? '80px' : '0px' }}>
                    {searchParams.has("autoLogout") &&
                        <div className={` col-10 col-md-12 col-lg-12 d-flex justify-content-center no-available-products mt-3`}>
                            <span>Nastąpiło automatyczne wylogowanie, zaloguj się ponownie.</span>
                        </div>
                    }

                    <div className='col-10 col-lg-4 main-container-holder' style={{ marginTop: isMobile ? '50px' : '150px', padding: '40px', marginRight: isMobile ? '0px' : '100px' }}>
                        <div className='row mb-3'>
                            <div className='col panel-header-title'>
                                Zaloguj się
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className='col'>
                                <InputDefault placeholder={'Email/Login'} type={'text'} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <InputDefault placeholder={'Hasło'} type={'password'} onChange={(e) => setPassword(e.target.value)} onKeyDown={handleKeyPress} />
                            </div>
                        </div>
                        <div className="row justify-content-center mt-2" style={{ color: 'red' }}>{loginError}</div>
                        <div className="options mt-3">
                            <div className='app-link' onClick={handleResetPassword}>Przypomnij hasło</div>
                        </div>
                        <div className='row  justify-content-center mt-4'>
                            <Button className='btn-app-primary button-size2' onClick={(e) => loginSubmit(e, null)} size='lg'>
                                {t('login_button_top_bar')}
                            </Button>
                        </div>
                    </div>
                    <div className='col-10 col-lg-4 main-container-holder' style={{ marginTop: isMobile ? '50px' : '150px', padding: '40px' }}>
                        <RegistrationItemList />
                        <div className='row justify-content-center' style={{ marginTop: '37px' }}>
                            <Link className='col-auto' to={'/Registration'}>
                                <Button className='btn-app-primary button-size2' size='lg' >
                                    {t('signUp')}
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </ErrorBoundary>
    </>)
}

export default LoginPageIndex